import groupBy from 'lodash.groupby'
import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'

import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { Domain } from '@pepper/utils/src/types/seo'

type Args = {
  companyId: string
  projectIds?: string[]
}

type Response = {
  records: {
    projectId: string
    domain: Domain
    total_topics: number
  }[]
  total_records: number
}

const STALE_TIME = 1000 * 60 * 10 // 10 mins

export async function getProjectDomainMap(
  companyId: string,
  projectIds?: string[]
) {
  const projectIdParam = projectIds
    ? `?project_id=${projectIds?.join('&project_id=')}`
    : ''
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/projects/v2${projectIdParam}`
  const response = await axios.get<Response>(url)

  return response.data
}

export function useProjectDomainMap({ companyId, projectIds }: Args) {
  const { data } = useQuery({
    queryKey: ['project-domain-map', companyId, projectIds],
    queryFn: () => getProjectDomainMap(companyId),
    enabled: !!companyId,
    retry: false,
    staleTime: STALE_TIME,
    refetchOnWindowFocus: 'always',
  })

  return {
    domainMap: data ? groupBy(data.records, 'project_id') : null,
  }
}
